const looping_video_segments = document.querySelectorAll('.looping-video-segment');

for(let looping_video_segment of looping_video_segments) {
  let start_time = looping_video_segment.getAttribute('start_time');
  let end_time = looping_video_segment.getAttribute('end_time');
  
  looping_video_segment.currentTime = start_time;
  looping_video_segment.play();
  
  looping_video_segment.addEventListener('timeupdate', function() {
    if (looping_video_segment.currentTime > end_time) {      
      looping_video_segment.currentTime = start_time;     
    }
  }, false);
}